import classNames from 'classnames';
import React from 'react';

var Jumbotron = function Jumbotron(_ref) {
  var _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      fluid = _ref.fluid,
      className = _ref.className;
  var classes = classNames(className, 'py-3 py-sm-5', fluid ? 'bg-light mb-4' : 'rounded px-3 px-sm-4');
  return /*#__PURE__*/React.createElement(Tag, {
    className: classes
  });
};

Jumbotron.displayName = "Jumbotron";
export default Jumbotron;